import { Injectable } from '@angular/core';
import {WebSocketSubject} from "rxjs/webSocket";
import {webSocket} from "rxjs/webSocket";
import {of, Subject} from "rxjs";
import {catchError, switchAll} from "rxjs/operators";
import { environment } from '../../../environments/environment';
import {HeizcheckConstants} from "../heizcheck.constants";
export const WS_ENDPOINT = environment.websockeEndpoint;

declare let __advisorWebsocketEndpoint;

/**
 * Service for connectiong and sending messages to the websocket server.
 */
@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  /**
   * Websocket subject for sending and receiving messages.
   */
  private myWebSocket: WebSocketSubject<any>;

  /**
   * private message subject for incomming message handling
   * @private
   */
  private messagesSubject$ = new Subject();

  /**
   * public subject where a componnt can subscribe to.
   */
  public messages$ = this.messagesSubject$.pipe(switchAll(), catchError(e => { throw e }));

  /**
   * Connect to the websocketserver.
   * If the connection is lost, there is an automatic reconnect.
   */
  public connect(id: string, sender: string): void {

    const websocketEndpoint = typeof __advisorWebsocketEndpoint === 'undefined'? WS_ENDPOINT : __advisorWebsocketEndpoint;
    this.myWebSocket = webSocket(websocketEndpoint);
    // for local dev only
    // this.myWebSocket = webSocket('wss://ws.advisor.co2online.de');
    this.myWebSocket.subscribe(
      message => this.messagesSubject$.next(of(message)),
      error => {
        // error accured in connection, try to reconnect.
        console.error("Error on Websocket connection", error);
        console.debug("try to reconnect");
        setTimeout(() => {
          this.connect(id, sender);
        }, 2000);
      }
    );

    this.sendMessage(id, sender, HeizcheckConstants.WEBSOCKET_MESSAGE_REGISTER);
  }

  /**
   * send a message to the websocket server.
   * @param id
   * @param sender
   * @param message
   * @param data
   */
  public sendMessage(id, sender, message, data: any = null): void {
    this.myWebSocket.next({id: id, sender: sender, message: message, data: data});
  }

  /**
   * closes the websocket connection
   */
  public closeConnection(): void {
    if(this.myWebSocket) {
      this.myWebSocket.complete();
    }
  }


}
